function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { T } from 'shared/helper/translate';
import { getAllowedFiletypesForNamespace } from '../selectors';
import Files from './Files';
import ReferenceFiles from './ReferenceFiles';
var FilesWithReferenceFiles = function FilesWithReferenceFiles(_ref) {
  var allowAnonymousUploads = _ref.allowAnonymousUploads,
    apiRoot = _ref.apiRoot,
    alertMessage = _ref.alertMessage,
    className = _ref.className,
    subheading = _ref.subheading,
    heading = _ref.heading,
    methods = _ref.methods,
    names = _ref.names,
    types = _ref.types;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    referenceFilesDisplayed = _useState2[0],
    setReferenceFilesDisplayed = _useState2[1];
  var application = useSelector(function (state) {
    return state.application;
  });
  var allowedFileTypes = getAllowedFiletypesForNamespace({
    application: application,
    type: types.main
  });
  var allowedFileTypeString = allowedFileTypes ? allowedFileTypes.join(', ') : '';
  var _methods$watch = methods.watch([names.reference]),
    _methods$watch2 = _slicedToArray(_methods$watch, 1),
    referenceFiles = _methods$watch2[0];
  useEffect(function () {
    if (referenceFiles && referenceFiles.length > 0 && !referenceFilesDisplayed) {
      setReferenceFilesDisplayed(true);
    }
  }, [referenceFiles && referenceFiles.length]);
  return /*#__PURE__*/React.createElement("fieldset", {
    className: className
  }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: heading
  })), subheading ? /*#__PURE__*/React.createElement(T.md, {
    source: subheading,
    params: allowedFileTypeString
  }) : null, /*#__PURE__*/React.createElement(Files, {
    allowAnonymousUploads: allowAnonymousUploads,
    apiRoot: apiRoot,
    methods: methods,
    name: names.main,
    type: types.main,
    required: true
  }), alertMessage ? /*#__PURE__*/React.createElement("div", {
    className: "alert alert-warning"
  }, /*#__PURE__*/React.createElement(T, {
    source: alertMessage
  })) : null, /*#__PURE__*/React.createElement(ReferenceFiles, {
    allowAnonymousUploads: allowAnonymousUploads,
    apiRoot: apiRoot,
    methods: methods,
    name: names.reference,
    type: types.reference,
    includeReferenceFiles: referenceFilesDisplayed,
    onReferenceInquiryUpdated: function onReferenceInquiryUpdated(referenceFilesDisplayed) {
      return setReferenceFilesDisplayed(referenceFilesDisplayed);
    }
  }));
};
export default FilesWithReferenceFiles;